module.exports = __webpack_public_path__ + "img/dividing-amoeba.702f0022.jpg";